import PropTypes from 'prop-types';
import Slider, { SliderTooltip } from 'rc-slider';
import React from 'react';

class Range extends React.PureComponent {
	constructor(props) {
		super(props);

		/**
		 * Use the constructor to push marks and startValue into state
		 * so it can be used in componentDidMount to trigger the onChange method
		 * (range input always has a kind of 'active' state so the user could
		 * just accept the current value and continue in the form)
		 */
		const {
			options,
			scaleOptions: { type },
			defaultValue,
		} = this.props;

		// Set marks
		let marks = {};
		if (type === 'fixed') {
			const steps = 100 / (options.length - 1);
			for (let i = 0, value = 0; i < options.length; i++, value += steps) {
				marks[value] = options[i].label;
			}
		} else {
			// type: percentage
			marks = {
				0: '0 %',
				100: '100 %',
			};
		}

		// Set start value
		let startValue;
		if (type === 'fixed') {
			const steps = 100 / (options.length - 1);

			if (defaultValue) {
				startValue = steps * defaultValue;
			} else {
				// Check if the number of options is even
				startValue = options.length % 2 === 0 ? steps * Math.ceil(options.length / 2) : 50;
			}
		} else {
			// type: percentage
			startValue = defaultValue ? defaultValue : 50;
		}

		this.state = {
			marks,
			startValue,
		};
	}

	componentDidMount = () => {
		this.props.handleChange(this.state.startValue);
	};

	render() {
		const {
			scaleOptions: { type, knob_type, tooltip, background, reverse },
			handleChange,
		} = this.props;

		const { Handle } = Slider;

		const handle = (props) => {
			const { value, dragging, index, ...restProps } = props;
			const tooltipText = tooltip.replace('[value]', type === 'percentage' ? value : this.state.marks[value]);

			return (
				<SliderTooltip prefixCls="rc-slider-tooltip" overlay={tooltipText} visible={dragging} placement="top" key={index}>
					<Handle value={value} {...restProps} />
				</SliderTooltip>
			);
		};

		const attributes = {
			className: `knob-type--${knob_type}`,
			included: background,
			reverse: reverse,
			marks: this.state.marks,
			step: type === 'fixed' ? null : 1,
			onChange: handleChange,
			defaultValue: this.state.startValue,
		};

		return <Slider {...attributes} {...(tooltip && { handle: handle })} />;
	}
}

export default Range;

Range.propTypes = {
	defaultValue: PropTypes.any,
	handleChange: PropTypes.any,
	options: PropTypes.any,
	scaleOptions: PropTypes.any,
};
